import { render, staticRenderFns } from "./UserBusinessDeatils.vue?vue&type=template&id=e38cba88&"
import script from "./UserBusinessDeatils.vue?vue&type=script&lang=js&"
export * from "./UserBusinessDeatils.vue?vue&type=script&lang=js&"
import style0 from "./UserBusinessDeatils.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports